import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Lock, Play, BadgeCheck, LogOut } from "lucide-react";
import { API } from "@/lib/config";

export const MemberVideos = ({ member, headers, onUnlock, onWatch, signOut }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    if (!member) { setVideos([]); return; }
    axios.get(`${API}/community/videos`, { headers }).then((r) => setVideos(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [member]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mt-16 border border-[#D4AF37]/20 bg-[#0A0E14] p-6 md:p-8 grain relative overflow-hidden" data-testid="member-videos">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37]">Crew Access</p>
          <h3 className="font-display text-lg md:text-xl tracking-[0.12em] text-[#F5F3EF] mt-2">MEMBERS-ONLY CUTS</h3>
        </div>
        {member ? (
          <div className="flex items-center gap-4 text-[11px] tracking-[0.15em] uppercase">
            <span className="flex items-center gap-2 text-[#E8C15A]" data-testid="member-badge">
              <BadgeCheck size={14} /> Verified · {member.email}
            </span>
            <button onClick={signOut} className="flex items-center gap-1 text-[#94A3B8] hover:text-[#E8C15A] transition-colors" data-testid="member-signout-btn">
              <LogOut size={12} /> Sign out
            </button>
          </div>
        ) : (
          <button onClick={onUnlock}
            className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#E8C15A] border border-[#D4AF37]/40 px-5 py-3 hover:bg-[#D4AF37]/10 transition-colors duration-300"
            data-testid="member-unlock-btn">
            <Lock size={13} /> Verify email to unlock
          </button>
        )}
      </div>

      {member ? (
        <div className="grid sm:grid-cols-3 gap-4 mt-6">
          {videos.map((v, i) => (
            <motion.button key={v.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              onClick={() => onWatch({ title: v.title, tagline: v.tagline, image: v.image })}
              className="group text-left" data-testid={`member-video-${v.id}`}>
              <div className="relative overflow-hidden border border-[#D4AF37]/25">
                <img src={v.image} alt={v.title} className="h-40 w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#070A0F]/80 via-transparent to-transparent" />
                <span className="absolute top-2 left-2 font-coords text-[9px] tracking-[0.25em] text-[#E8C15A] bg-[#070A0F]/70 border border-[#D4AF37]/30 px-2 py-1">{v.badge}</span>
                <span className="absolute inset-0 m-auto h-11 w-11 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] flex items-center justify-center bg-[#070A0F]/40 group-hover:bg-[#D4AF37] group-hover:text-[#070A0F] transition-colors duration-300">
                  <Play size={16} fill="currentColor" className="ml-0.5" />
                </span>
              </div>
              <h4 className="font-display text-xs tracking-[0.12em] text-[#F5F3EF] mt-3 group-hover:text-[#E8C15A] transition-colors">{v.title}</h4>
              <p className="font-editorial italic text-sm text-[#94A3B8]">{v.tagline}</p>
            </motion.button>
          ))}
        </div>
      ) : (
        <div className="grid sm:grid-cols-3 gap-4 mt-6" data-testid="member-videos-locked">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-40 border border-[#D4AF37]/15 bg-[#070A0F] flex items-center justify-center">
              <Lock size={18} className="text-[#D4AF37]/40" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
